//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';
import { getUserTimeZone } from '@redux/selectors/getUserTimeZone';

export const isDateEarlierThan30DaysAgo = (
  date: DateString,
  timezone: TimeZoneId,
): boolean => {
  const today = DateString.getToday(timezone);
  const todayMinus30Days = DateString.addDays(today, -30);

  return DateString.compare(date, todayMinus30Days) < 0;
};

// Disable the checkbox if the selected end date is earlier than the date 30 days ago
export const getShouldDisableLast30Days = createSelector(
  getUserTimeZone,
  (state: ICuralateStore) => state.pinterest.engagement.dateRange,
  (userTimezone, dateRange) =>
    isDateEarlierThan30DaysAgo(dateRange.endDate, userTimezone),
);
